import React, { useEffect, useState } from "react";
import { motion } from "motion/react";
import { useLocation } from "react-router-dom";

import { App, Auth } from "../../../routes/Constants";
import StyledFooter from "./StyledFooter";
import { SupportText } from "./SupportText";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";

const Footer = () => {
  const location = useLocation();
  const reducedMotion = usePrefersReducedMotion();
  const [isLoginPage, setIsLoginPage] = useState(false);
  const [isDashboardPage, setIsDashboardPage] = useState(false);

  useEffect(() => {
    const newIsLoadingValue =
      window.location.pathname.includes(Auth.LOGIN) ||
      window.location.pathname.includes(Auth.RESET_PASSWORD_VALIDATE_DEFAULT) ||
      window.location.pathname.includes(Auth.RESET_PASSWORD) ||
      window.location.pathname.includes(Auth.VALIDATE_DEFAULT);

    if (newIsLoadingValue !== isLoginPage) setIsLoginPage(newIsLoadingValue);

    const newIsDashboardValue = window.location.pathname === App.DASHBOARD;

    if (newIsDashboardValue !== isDashboardPage)
      setIsDashboardPage(newIsDashboardValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <StyledFooter data-testid="footer">
      <div
        className={
          isLoginPage
            ? "main-wrapper-footer-login"
            : "main-wrapper-footer-general"
        }
        data-testid="footer-main"
      >
        <div className="wrapper-footer">
          <div className="center">
            <div className="wrapper-footer-loggedin">
              {isLoginPage ? (
                <SupportText
                  className="logo-container "
                  className2="support-login"
                  className3="logos"
                  showLogos={true}
                />
              ) : (
                <div className="flex flex-col items-center justify-center gap-4">
                  {isDashboardPage ? (
                    <React.Fragment>
                      <motion.div
                        className="flex flex-col items-center gap-4"
                        initial={reducedMotion ? false : { opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: reducedMotion ? 0 : 0.6,
                          delay: reducedMotion ? 0 : 0.8,
                        }}
                      >
                        <motion.div
                          className="flex items-center gap-4"
                          initial={reducedMotion ? false : { y: 20, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          transition={{ delay: reducedMotion ? 0 : 0.9 }}
                          whileHover={reducedMotion ? {} : { scale: 1.05 }}
                        >
                          <img src="/icons/Pathfinder.png" alt="PathFinder Logo" />
                        </motion.div>
                        <motion.div
                          initial={reducedMotion ? false : { y: 20, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          transition={{ delay: reducedMotion ? 0 : 1.0 }}
                        >
                          <SupportText />
                        </motion.div>
                      </motion.div>
                    </React.Fragment>
                  ) : (
                    <div />
                  )}

                  {!isDashboardPage && <SupportText />}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
};
export default Footer;
